class CommonService {
    /*@ngInject*/
    constructor($log, $http, $rootScope) {
        this.$log = $log;
        this.$http = $http;
        this.$rootScope = $rootScope;
        this.personalizeRequestResponse = null;
        this.baseUrl = ACC.config.encodedContextPath;
    }

    // FIXME: async function and getPersonalizeRequestResponse is called several times sync. Use promise (see SERMA?)
    personalRequest() {
        this.$log.debug('sending personalize request');

        let url = this.getBaseUrl() + '/personalize';

        this.$http.get(url, null)
            .then((response) => {
                if (response.status >= 500) {
                    this.$log.error('personalize request error: ' + response.status + ' ' + response.statusText);
                    window.location.replace('/');
                } else if (response.status >= 400) {
                    this.$log.error('personalize request not found: ' + response.status + ' ' + response.statusText);
                    window.location.replace('/');
                } else if (response.status >= 300) {
                    window.location.replace(response.headers['Location']);
                } else {
                    this.personalizeRequestResponse = response.data;
                    this.redirectIfRequired(this.personalizeRequestResponse.path);
                    this.putDataIntoEshopDatalayer();
                    this.dynamicYieldLoginEvent(this.personalizeRequestResponse.dyLoginTrackingData);
                    this.dynamicYieldSignUpEvent(this.personalizeRequestResponse.dySignUpTrackingData);
                    // info for algolia
                    window.algoliaEncodedEmail = this.personalizeRequestResponse.encodedEmail;
                    this.$rootScope.$broadcast('personalizeRequestSuccess');
                    if (window.dataLayer !== undefined) {
                        dataLayer.push({'event': 'personalizeRequestSuccess'});
                    }
                }
            }, (error) => {
                this.$log.error('personalize request: ' + error.status + ' ' + error.statusText);
            });

    }

    putDataIntoEshopDatalayer() {
        if (window.dataLayer !== undefined) {
            dataLayer.push({
                'hashed_email': this.personalizeRequestResponse.encodedEmail,
                'email': this.personalizeRequestResponse.email,
                'member_id': this.personalizeRequestResponse.memberId,
                'cartEntries': this.personalizeRequestResponse.cartEntries,
            });
        }
    }

    dynamicYieldLoginEvent(dyLoginTrackingData) {
        const dyLoginEval = function() {
            if(typeof DY === 'object' && typeof DY.API === 'function') { // DY.API() is available?
                DY.API("event", {
                    name: "Login",
                    properties: {
                        dyType: dyLoginTrackingData.dyType,
                        hashedEmail: dyLoginTrackingData.hashedEmail
                    }
                });
                return true;
            }
            else {
                return false;
            }
        };

        if (dyLoginTrackingData !== null) {
            if(!dyLoginEval()) {
                const dyLoginInterval = setInterval(function () {
                    if (dyLoginEval()) { // remove the interval once the DY.API was available
                        clearInterval(dyLoginInterval);
                    }
                }, 1000);
            }
        }
    }

    dynamicYieldSignUpEvent(dySignUpTrackingData) {
        if (dySignUpTrackingData !== null) {
            try {
                if (typeof DY != "undefined") {
                    DY.API("event", {
                        name: "Signup",
                        properties: {
                            dyType: dySignUpTrackingData.dyType,
                            hashedEmail: dySignUpTrackingData.hashedEmail
                        }
                    });
                }
            } catch (e) {
                console.warn("can't send DY signup event");
            }
        }
    }

    getPersonalizeRequestResponse() {
        return this.personalizeRequestResponse;
    }

    /**
     * Returns base url without trailing slash
     *
     * @return {string} base url
     */
    getBaseUrl() {
        return this.baseUrl;
    }

    redirectIfRequired(extendedCountryCode) {
        if (extendedCountryCode === undefined || extendedCountryCode === null) {
            window.location.replace('/');
        } else if (!window.location.pathname.startsWith('/' + extendedCountryCode)) {
            window.location.replace('/' + extendedCountryCode);
        }
    }
}

export default CommonService;
